'use client'
import Image from "next/image";
import { useRouter } from "next/navigation";
import en from "../../public/locale/en";
import hi from "../../public/locale/hi";
import ta from "../../public/locale/ta";
import AccordionItem from "../Accordion/AccordionItem";
import ArticleFooter from "../ArticleFooter";
const FooterLink = ({ href, target, text = "", isImage }) => {
  const slug = text.split(" ").join("-").toLowerCase();
  return (
    <li id={`footer-link-${slug}`} className="mb-3">
      <a
        id={`footer-link-anchor-${slug}`}
        href={href || "#"}
        target={target || "_self"}
        className="footer-redirections font-roboto-regular text-defaultblack text-decoration-none pb-2"
      >
        {isImage ? (
          <Image
            id="bima-bharosa-logo"
            src="/aem-to-react/bima_bharosa/Bima-Bharosa-Logo.jpg"
            alt="BIMA BHAROSA"
            width={130}
            height={30}
          />
        ) : (
          text
        )}
      </a>
    </li>
  );
};

const FooterSection = ({ title = "", links = [], newDesignConfig }) => {
  const sectionSlug = title.split(" ").join("-").toLowerCase();
  return (
    <div id={`footer-section-${sectionSlug}`} className="w-full">
      <p
        id={`footer-section-title-${sectionSlug}`}
        className={`mb-3 pb-2 text-xl font-semibold hidden md:flex ${
          newDesignConfig ? "text-nivabupa-blue-ethinosPlanRecommendation" : ""
        }`}
      >
        {title}
      </p>
      <ul
        id={`footer-section-links-${sectionSlug}`}
        className={`list-none p-0 m-0 md:text-base text-sm ${
          newDesignConfig ? "text-black" : ""
        }`}
      >
        {links.map((link, index) => (
          <FooterLink key={index} {...link} />
        ))}
      </ul>
    </div>
  );
};


const FollowUs = () => (
  <div id="follow-us" className="flex flex-col items-center justify-center mb-4">
    <div className="text-center">
      <p className="font-rubik font-semibold">Follow us</p>
    </div>
    <ul className="flex justify-center mt-2 items-center">
      <li className="mx-4">
        <a
          href="https://www.facebook.com/NivaBupa"
          target="_blank"
          rel="noreferrer noopener"
          title=""
        >
          <Image
            id="facebook-icon"
            src="/aem-to-react/icons/facebook-icon.svg"
            alt="Facebook"
            title="Facebook"
            width={7}
            height={15}
          />
        </a>
      </li>

      <li className="mx-4">
        <a
          href="https://twitter.com/Niva_Bupa"
          target="_blank"
          rel="noreferrer noopener"
          title=""
        >
          <Image
            id="twitter-icon"
            src="/aem-to-react/icons/twitter-icon.svg"
            alt="Twitter"
            title="Twitter"
            width={13}
            height={9}
          />
        </a>
      </li>

      <li className="mx-4">
        <a
          href="https://www.linkedin.com/company/niva-bupa/"
          target="_blank"
          rel="noreferrer noopener"
          title=""
        >
          <Image
            id="linkedin-icon"
            src="/aem-to-react/icons/linkedin-icon.svg"
            alt="LinkedIn"
            title="LinkedIn"
            width={13}
            height={13}
          />
        </a>
      </li>

      <li className="mx-4">
        <a
          href="https://www.youtube.com/c/nivabupa"
          target="_blank"
          rel="noreferrer noopener"
          title=""
        >
          <Image
            id="youtube-icon"
            src="/aem-to-react/icons/youtube-icon.svg"
            alt="YouTube"
            title="YouTube"
            width={15}
            height={11}
          />
        </a>
      </li>
    </ul>
  </div>
);

const AppDownloadLinks = () => {
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : locale === "hi" ? hi : ta;

  return (
    <div id="app-download-links" className="mb-3 d-flex flex-column align-items-center">
      <div className="flex-column">
        <div className="font-semibold pb-1 text-center">
          {t["Download Our App"]}
        </div>
        <div className="py-2 flex flex-row gap-4 justify-center">
          <a
            href="https://play.google.com/store/apps/details?id=com.maxbupa.healthapp"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Image
              id="play-store-icon"
              src="/aem-to-react/playstore-images/google-play.png"
              className="secondLastFooter_img__AKxFh"
              title="Play Store"
              alt="App"
              loading="lazy"
              decoding="async"
              width="150"
              height="0"
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/niva-bupa-health/id1383647191"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Image
              id="app-store-icon"
              src="/aem-to-react/playstore-images/app-store.png"
              className="secondLastFooter_img__AKxFh"
              title="App Store"
              alt="App"
              loading="lazy"
              decoding="async"
              width="150"
              height="0"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

const AEMFooter = ({ newDesignConfig }) => {
  const router = useRouter();
  const locale = router.locale || "en";
  const t = locale === "en" ? en : locale === "hi" ? hi : ta;

  const sections = [
    {
      title: t["Insurance Plans"],
      links: [
        {
          href: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
          target: "_self",
          text: t["Health Insurance"],
        },
        // {
        //   href: "https://www.nivabupa.com/health-insurance/health-insurance-plans.html",
        //   target: "_self",
        //   text: t["Health Insurance Plans"],
        // },
        {
          href: "https://www.nivabupa.com/health-insurance/individual-health-insurance-plans.html",
          target: "_self",
          text: t["Individual Health Insurance Plans"],
        },
        {
          href: "https://www.nivabupa.com/health-insurance/family-health-insurance-plans.html",
          target: "_self",
          text: t["Family Health Insurance Plans"],
        },
        {
          href: "https://www.nivabupa.com/health-insurance/critical-illness-insurance.html",
          target: "_self",
          text: t["Critical Illness Insurance Plans"],
        },
        {
          href: "https://www.nivabupa.com/health-insurance/personal-accident-insurance.html",
          target: "_self",
          text: t["Personal Accident Insurance Plans"],
        },
        {
          href: "https://www.nivabupa.com/health-insurance/mediclaim.html",
          target: "_self",
          text: t["Mediclaim Policy"],
        },
        {
          href: "https://www.nivabupa.com/travel-insurance.html",
          target: "_self",
          text: t["Travel Insurance"],
        },
        {
          href: "https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html",
          target: "_self",
          text: t["Best Health Insurance for Senior Citizens"],
        },
        {
          href: "https://www.nivabupa.com/health-insurance/nri.html",
          target: "_self",
          text: t["NRI Health Insurance"],
        },
        {
          href: "https://health-insurance-nearme.nivabupa.com/",
          target: "_blank",
          text: t["Niva Bupa Store Locator"],
        },
        {
          href: "https://www.nivabupa.com/Empower/GetQuote",
          target: "_blank",
          text: t["Empower Health Plan"],
        },
        {
          href: "https://www.nivabupa.com/Insure/GetQuote/surrogate",
          target: "_blank",
          text: t["SurroGuard Health Plan"],
        },
        {
          href: "https://www.nivabupa.com/Insure/GetQuote/oocyte",
          target: "_blank",
          text: t["Oocyte Guard Health Plan"],
        },
      ],
    },
    {
      title: t["About Niva Bupa"],
      links: [
        {
          href: "https://transactions.nivabupa.com/pages/about-us.aspx",
          target: "_blank",
          text: t["About Us"],
        },
        {
          href: "/contact-us.html",
          target: "_blank",
          text: t["Contact Us"],
        },
        {
          href: "https://transactions.nivabupa.com/unclaimed/unclaimedamount.aspx",
          target: "_blank",
          text: t["Unclaimed Amount"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/media-center.aspx",
          target: "_blank",
          text: t["Media Center"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/public-disclosures.aspx",
          target: "_blank",
          text: t["Public Disclosures"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/investor-relations.aspx",
          target: "_blank",
          text: t["Investor Relations"],
        },
        {
          href: "https://www.bupa.com/",
          target: "_blank",
          text: t["Bupa"],
        },
        {
          href: "https://truenorth.co.in/",
          target: "_blank",
          text: t["True North"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/promoters.aspx",
          target: "_blank",
          text: t["Promoters"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/management-team.aspx",
          target: "_blank",
          text: t["Our Management"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/board-of-directors.aspx",
          target: "_blank",
          text: t["Board of Directors"],
        },
        {
          href: "https://www.nivabupa.com/content/dam/nivabupa/PDF/ESGPolicy.pdf",
          target: "_blank",
          text: t["ESG Policy"],
        },
        {
          href: "https://www.nivabupa.com/content/dam/nivabupa/PDF/Supplier%20code%20of%20conduct_ao_1aug_2.pdf",
          target: "_blank",
          text: t["Supplier Code Of Conduct"],
        },
      ],
    },
    {
      title: t["Tools for You"],
      links: [
        {
          href: "/health-insurance-articles.html",
          target: "_self",
          text: t["Articles"],
        },
        {
          href: "https://transactions.nivabupa.com/services/pages/sales_dst.aspx",
          target: "_blank",
          text: t["Channel Payment"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/health-insurance-terms.aspx",
          target: "_blank",
          text: t["Glossary"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/grievance-redressal.aspx",
          target: "_blank",
          text: t["Customer Grievance Redressal"],
        },
        {
          href: "https://transactions.nivabupa.com/Pages/career.aspx",
          target: "_blank",
          text: t["Careers"],
        },
        {
          href: "/insure-care.html",
          target: "_blank",
          text: t["Insure Care"],
        },
        {
          href: "https://otc.nivabupa.com/t/RegisterforAutoRenewal",
          target: "_blank",
          text: t["Auto Renewal"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/do-not-disturb-registry.aspx",
          target: "_blank",
          text: t["Do Not Disturb Registry"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/downloads.aspx",
          target: "_blank",
          text: t["Download Center"],
        },
        {
          href: "/content/dam/nivabupa/PDF/20230707OrrisaTrainAccident.pdf",
          target: "_blank",
          text: t["Balasore Train Accident"],
        },
        {
          href: "/abha/Index",
          target: "_blank",
          text: t["ABHA Health ID"],
        },
        {
          href: "https://www.nivabupa.com/health-insurance-premium-calculator-new.html",
          target: "_blank",
          text: t["Premium Calculator"],
        },
        {
          href: "https://bimabharosa.irdai.gov.in/",
          target: "_blank",
          text: t["BIMA BHAROSA"],
          isImage: true,
        },
      ],
    },
    {
      title: t["Legal"],
      links: [
        {
          href: "https://www.policyholder.gov.in/",
          target: "_blank",
          text: t["IRDA Consumer Education"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/stewardship-policy.aspx",
          target: "_blank",
          text: t["Stewardship Policy"],
        },
        {
          href: "https://transaction.nivabupa.com/Pages/doc/other/UnderwritingPhilosophy.pdf",
          target: "_blank",
          text: t["Underwriting Philosophy"],
        },
        {
          href: "/help-centre/help-terms-and-condition.html",
          target: "_self",
          text: t["Website Terms & Conditions"],
        },
        {
          href: "/help-centre/privacypolicy.html",
          target: "_self",
          text: t["Privacy Policy & Disclaimers"],
        },
        {
          href: "https://www.cioins.co.in/Ombudsman",
          target: "_blank",
          text: t["Insurance Ombudsman"],
        },
        {
          href: "https://www.nivabupa.com/content/dam/nivabupa/PDF/Modified%20and%20Withdrawn%20Products_22nd%20November%202023.pdf",
          target: "_blank",
          text: t["Products Updated & Withdrawn List"],
        },
        {
          href: "https://www.nivabupa.com/content/dam/nivabupa/PDF/Installment%20Options%20in%20Products_22nd%20November%202023.pdf",
          target: "_blank",
          text: t["Installment Premium Product List"],
        },
        {
          href: "https://www.nivabupa.com/content/dam/nivabupa/PDF/List%20of%20Products%20Offered_22nd%20November%202023.pdf",
          target: "_blank",
          text: t["List of Products Offered"],
        },
        {
          href: "https://www.nivabupa.com/content/dam/nivabupa/PDF/20230725Whistleblower.pdf",
          target: "_blank",
          text: t["Whistleblower Policy"],
        },
        {
          href: "https://transactions.nivabupa.com/pages/doc/reports/3rd_Party_reporting.pdf",
          target: "_blank",
          text: t["Infosec Incident Reporting"],
        },
      ],
    },
    {
      title: t["Log In"],
      links: [
        {
          href: "https://transactions.nivabupa.com/pages/health-care-providers.aspx",
          target: "_blank",
          text: t["Service Provider"],
        },
        {
          href: "https://spectrum.nivabupa.com/spectrum/login.aspx",
          target: "_blank",
          text: t["Agents"],
        },
        {
          href: "https://healthlink.nivabupa.com/HLCL/UI/Logon/ClientPortalLogin.aspx",
          target: "_blank",
          text: t["Health Link Portal"],
        },
        {
          href: "https://www.mygov.in/mygov-survey/irdais-call-centre-feedback-survey",
          target: "_blank",
          text: t["IRDAI Call Centre Feedback Survey"],
        },
      ],
    },
  ];

  return (
    <div
    id="footer-container"
    className={`flex-col flex gap-4 overflow-x-hidden ${
      newDesignConfig ? "border-b border-gray-500" : ""
    }`}
  >
    <div
      id="footer-sections"
      className={`font-rubik md:grid md:grid-cols-5 gap-4 w-full p-4 ${
        newDesignConfig
          ? "bg-transparent"
          : "bg-nivabupa-homepage-gray border-b border-gray-300"
      }  hidden md:visible`}
    >
      {sections.map((section, index) => (
        <FooterSection
          key={index}
          id={`footer-section-${index}`}
          {...section}
          newDesignConfig={newDesignConfig}
        />
      ))}
    </div>
    <div
      id="accordion-sections"
      className={`font-rubik flex flex-col gap-4 w-full p-4 ${
        newDesignConfig ? "bg-transparent" : "bg-nivabupa-homepage-gray"
      } border-b border-gray-300 md:hidden`}
    >
      {sections.map((section, index) => (
        <AccordionItem
          key={index}
          id={`accordion-item-${index}`}
          title={section.title}
          content={
            <FooterSection
              key={index}
              id={`accordion-footer-section-${index}`}
              {...section}
              newDesignConfig={newDesignConfig}
            />
          }
          newDesignConfig={newDesignConfig}
          defaultActive={true}
          // isActive={activeItem === index}
          // toggleItem={() => toggleAccordionItem(index)}
        />
      ))}
    </div>
    {!newDesignConfig && (
      <>
        <FollowUs />
        <AppDownloadLinks />
        <ArticleFooter />
      </>
    )}
  </div>
  
  );
};

export default AEMFooter;
